import {
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_ERROR_MESSAGE,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_FILE,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_NUMBER,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_STEP
} from "../../../constants/actionTypes";

export const setJobPurchaseOrderPopupStep = (purchaseOrderStep) => ({
  type: JOB_BOARD_PURCHASE_ORDER_POPUP_SET_STEP,
  payload: {purchaseOrderStep}
})

export const setJobPurchaseOrderInvoiceNumber = (purchaseOrderInvoiceNumber) => ({
  type: JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_NUMBER,
  payload: {purchaseOrderInvoiceNumber}
})

export const setJobPurchaseOrderInvoiceFile = (purchaseOrderInvoiceFile = null) => ({
  type: JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_FILE,
  payload: {purchaseOrderInvoiceFile}
})

export const setJobPurchaseOrderErrorMessage = (purchaseOrderErrorMessage = "") => ({
  type: JOB_BOARD_PURCHASE_ORDER_POPUP_SET_ERROR_MESSAGE,
  payload: {purchaseOrderErrorMessage}
})
